import { render, staticRenderFns } from "./ProfilMahasiswa.vue?vue&type=template&id=7c8f9cf2"
import script from "./ProfilMahasiswa.vue?vue&type=script&lang=js"
export * from "./ProfilMahasiswa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports